export default __webpack_public_path__ + "static/media/40256.fab527ee.jpg";